var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"md":"2"}},[_c('span',[_vm._v(_vm._s(_vm.projectEvent.createdBy ? _vm.projectEvent.createdBy.name : ''))])])}
var staticRenderFns = []

export { render, staticRenderFns }